export default function checkoutForm({ main, on, elm, state }) {
	const confirmBtn = document.querySelector('[data-confirm]');
	const formValidation = elm.querySelector('form-validation');

	main(_ => {
		formValidation.setValues({
			'agreement': 1
		});

		on('form-validation:submit', 'form', confirm)
	});

	const confirm = async function (e, { data }) {
		const {language} = state.get();
		const action = `index.php?route=extension/evasota/checkout/confirm&language=${language}`;
		const formData = new FormData();

		Object.entries(data).forEach(([key, value]) => {
			formData.append(key, value);
		});

		try {
			state.set(s => s.loading = true);
			const response = await fetch(action, {
				method: 'POST',
				body: formData,
				headers: {
					'X-Requested-With': 'XMLHttpRequest'
				}
			});

			if (!response.ok) {
				throw new Error(`Request failed: ${response.status}`);
			}

			const result = await response.json();

			const waitForConfirm = new Promise(resolve => {
				document.dispatchEvent(new CustomEvent('confirm', {
					detail: { resolve }
				}));
			});

			await waitForConfirm;

			if (result.redirect) {
				location.href = result.redirect;
			}
		} catch (e) {
			console.error(e);
		} finally {
			state.set(s => s.loading = false);
		}
	};
};

export const model = {
	loading: false
};
